// src/components/Projects.js
import React from 'react';

const Projects = () => {
    return (
        <section id="projects" className="section-content">
            <h2>Projects</h2>
            <div className="project-list">
                <ul>
                    <li className="list-li"><a href="https://deep1327007.github.io/Guess-The-Number/">Guess The Number</a></li>
                    <li className="list-li"><a href="https://deep1327007.github.io/Weather-Website/">Current Weather</a></li>
                    <li className="list-li"><a href="https://deep1327007.github.io/Keeper/">Keeper</a></li>
                    <li className="list-li"><a href="https://deep1327007.github.io/To-Do-Items/">To Do Items</a></li>
                    <li className="list-li"><a href="https://deep1327007.github.io/Tell-The-Time/">Tell The Time</a></li>
                    <li className="list-li"><a href="https://deep1327007.github.io/Netflix-Clone/">Netflix Home Page</a></li>
                    <li className='list-li'><a href="https://product-store-kguq.onrender.com/"> Product Store</a></li>
                </ul>
            </div>
        </section>
    );
};

export default Projects;
